import { render, staticRenderFns } from "./TraditionalQuestion.vue?vue&type=template&id=6e8aa4a7&scoped=true&"
import script from "./TraditionalQuestion.vue?vue&type=script&lang=js&"
export * from "./TraditionalQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TraditionalQuestion.vue?vue&type=style&index=0&id=6e8aa4a7&prod&scoped=true&lang=scss&"
import style1 from "./TraditionalQuestion.vue?vue&type=style&index=1&id=6e8aa4a7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8aa4a7",
  null
  
)

export default component.exports